import { render, staticRenderFns } from "./FieldTab.vue?vue&type=template&id=94cb8430"
import script from "./FieldTab.vue?vue&type=script&lang=js"
export * from "./FieldTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports